module.exports = __webpack_public_path__ + "img/格拉斯哥icon.48119283.png";